<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="javascript:void(0)">
    Inspection/Audit Templates
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <span class="mr-auto">
      <button *ngIf="canCreate" mat-raised-button color="primary" (click)="add()" id="add" class="m-1 mr-2">
        <mat-icon>add</mat-icon>
        Add Template
      </button>

      <ng-container *ngIf="canDelete">
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="dataSource.selectAllToggle()">
            <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
            {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
          </button>
          <button mat-menu-item (click)="onRemoveSelected()" [disabled]="!dataSource.selection.hasValue()">
            <mat-icon>delete</mat-icon> Delete Selected
          </button>
        </mat-menu>

        <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Inspection/Audit Templates." style="min-width: 120px">
          <mat-icon>more_vert</mat-icon>
          List Menu
        </button>
      </ng-container>
    </span>

    <button type="button" mat-raised-button class="m-1 mr-xl-3" *ngIf="canView" (click)="chartsUtils.onOpenMasterCharts('Inspections & Audits')" matTooltip="Click this button to open the charts.">
      <mat-icon>bar_chart</mat-icon> Charts
    </button>

    <form class="form-inline mx-1 my-0" *ngIf="canView" (ngSubmit)="dataSource.getData(true)">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        aria-label="Search" />

      <button
        mat-raised-button
        class="mx-0 my-1"
        color="secondary"
        id="searchButton"
        type="submit">
        <mat-icon>search</mat-icon>Search
      </button>
    </form>
  </div>

</nav>

<div class="alert alert-warning m-2" *ngIf="!canView">
  <mat-icon class="align-middle mr-2">info</mat-icon>
  You do not have permission to view inspection/audit templates.
  <span *ngIf="canCreate">You can still create new inspection/audit templates using the button above.</span>
  <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
</div>

<ng-container *ngIf="canView">
  <app-site-audits-charts-container [baseStorageKey]="'audits-inspections-templates'"></app-site-audits-charts-container>
</ng-container>

<div class="mat-elevation-z8 scroll-box" *ngIf="canView">
  <table
    mat-table
    [dataSource]="dataSource"
    style="width: 100%"
    matSort
    matSortActive="name"
    matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        #
      </th>
      <td mat-cell *matCellDef="let audit" class="no-padding">
        {{ audit.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Inspection/Audit Template
      </th>
      <td mat-cell *matCellDef="let audit" class="no-padding text-wrap">
        {{ audit.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="positive_comments">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Positive Comments
      </th>
      <td mat-cell *matCellDef="let audit" class="no-padding">
        {{ audit.positive_comments | ellipsis: ['30'] }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Date Created
      </th>
      <td mat-cell *matCellDef="let audit" class="no-padding">
        {{ (audit.date_created * 1000) | timezoneConvertMedium }} <br/>
        {{ (audit.date_created * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Date Created (UTC)
      </th>
      <td mat-cell *matCellDef="let audit" class="no-padding">
        {{ (audit.date_created * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>

      <td mat-cell *matCellDef="let audit">
        <button *ngIf="canView" type="button" mat-button [routerLink]="audit.id + '/view'">
          View
        </button>

        <button *ngIf="canEdit" type="button" mat-button (click)="edit(audit)">
          Edit
        </button>

        <button *ngIf="canDelete" type="button" mat-button (click)="onRemove(audit)">
          Delete
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
